import { clearAuthFromLocalStorage } from '@lib/auth';
import { environment } from '@lib/environment';

export const Logout: React.FC = ({ children }) => {
    clearAuthFromLocalStorage();
    window.location.href = `${environment.REACT_APP_IDP_URL()}/logout`;

    return <>{children}</>;
};
